import React, { useMemo, useState } from "react";
import { CheckLabel, DataTable, OneLineShowMore, Table, } from "@sscs/ui";
import { PolicyAudit } from "../../../common";
import { useLevels } from "../../../hooks";
import FileName from "../fileName/FileName";
import styles from "./threatHunting.module.scss";
const COLUMNS = [
    { id: "audit", label: "Audit", width: "80px" },
    { id: "fileName", label: "File name", width: "300px" },
    { id: "filePath", label: "File path", width: "100%" },
];
const FilesList = ({ id, files, override, }) => {
    const { scanLevel, isLevelCustomized } = useLevels();
    const [focusedRow, setFocusedRow] = useState(null);
    // In most cases, this table will have exactly one file. Pagination is done on frontend just in case
    // Putting it in redux state so it persists when navigating seemed like too much work for something that may never happen
    const [pagination, setPagination] = useState({
        currentPage: 1,
        itemsPerPage: 5,
    });
    const paginatedData = useMemo(() => {
        const offset = (pagination.currentPage - 1) * pagination.itemsPerPage;
        return files.slice(offset, offset + pagination.itemsPerPage);
    }, [pagination, files]);
    return (React.createElement(DataTable, { title: React.createElement(CheckLabel, { className: styles["icon-label"], scanLevel: scanLevel, status: override.status, isLevelCustomized: isLevelCustomized }), titleDetails: [override.enabled ? "Enabled" : "Disabled"], columns: COLUMNS, pagination: {
            id: `diff-${id}-pagination`,
            itemCount: files.length,
            pagination,
            onChange: setPagination,
            initialItemCount: 5,
        }, status: {
            status: "SUCCESS",
        }, className: styles["files-table"] }, paginatedData.map((file, index) => (React.createElement(DataTable.ExpandedRow, { key: file.id, disabled: !file.audit.present, focused: focusedRow === file.id, onClick: () => setFocusedRow(file.id) },
        React.createElement(DataTable.ExpandedRow.Summary, null,
            React.createElement(Table.Cell, null,
                React.createElement(FileName, { index: index, file: file })),
            React.createElement(Table.Cell, null,
                React.createElement(OneLineShowMore, { id: `diff-${id}-show-more-less-${index}`, value: file.path }))),
        React.createElement(DataTable.ExpandedRow.Details, null,
            React.createElement(PolicyAudit, { audit: file.audit, className: styles["audit-container"] })))))));
};
export default FilesList;
//# sourceMappingURL=FilesList.js.map